export const MAX_ASSET_SIZE = 50e6;
//# sourceMappingURL=assets.js.map